import { useCallback } from "react";
import Link from "next/link";
import Head from "next/head";
import { useRouter } from "next/router";

import config from "config";
import { AuthLayout } from "auth";
import UploadData from "modules/data-files/elements/upload-files";

const DATA_FILES_URL = "/data-files";

const DataUpload = () => {
  const router = useRouter();
  const redirect = useCallback(() => router.push(DATA_FILES_URL), [router]);
  return (
    <div className="max-w-screen-xl mx-auto px-4 sm:px-6">
      <Head>
        <title>{config.SITE_NAME} | Upload Data</title>
      </Head>
      <div className="pb-4 mb-8">
        <h1 className="h2 text-center">Upload Data</h1>
      </div>
      <UploadData
        onComplete={redirect}
        onError={
          <p className="bg-primary-main font-semibold py-2 my-2 text-center text-primary-contrastText text-xl w-full">
            <Link href={DATA_FILES_URL}>Go to Data Files</Link>
          </p>
        }
      />
    </div>
  );
};
DataUpload.getLayout = (page) => <AuthLayout>{page}</AuthLayout>;

export default DataUpload;
